module.exports = __webpack_public_path__ + "static/media/500013.c61411e3.svg";